import React, { useEffect, useRef, useState } from "react";
import { getCameraState } from "../../helperfunctions/getCameraState";
import {
  handlePrizeCollected,
  hasPrizeBeenCollected,
} from "../../helperfunctions/handlePrizeCollected";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Button } from "@radix-ui/themes";
export const TreasureHuntButtons = ({
  openCamera,
  setOpenCamera,
  hasAllCodes,
  setIsCameraConnected,
  onPaddingChange,
}: {
  openCamera: any;
  setOpenCamera: any;
  hasAllCodes: boolean;
  setIsCameraConnected: any;
  onPaddingChange: (padding: number) => void;
}) => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const prizeCollected = hasPrizeBeenCollected(currentUser);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current) {
      const buttonHeight = buttonRef.current.offsetHeight;
      onPaddingChange(buttonHeight);
    }
  }, []);

  const checkCameraState = async () => {
    const hasCamera = await getCameraState();
    if (hasCamera) {
      setIsCameraConnected(hasCamera);
      setOpenCamera(hasCamera);
    }
  };

  if (openCamera) {
    return (
      <Button
        onClick={() => {
          setOpenCamera(false);
        }}
      >
        Close camera
      </Button>
    );
  }

  if (!openCamera && !hasAllCodes && !prizeCollected) {
    return (
      <Button
        ref={buttonRef}
        onClick={async () => {
          checkCameraState();
        }}
      >
        Scan the qr code
      </Button>
    );
  }

  if (!openCamera && hasAllCodes && !prizeCollected) {
    return (
      <Button
        onClick={() => {
          handlePrizeCollected(currentUser);
        }}
      >
        I have collected the prize
      </Button>
    );
  }

  if (!openCamera && prizeCollected) {
    return (
      <Button variant="soft" disabled>
        I have collected the prize
      </Button>
    );
  }
};
